import axios from "axios";
//import store from "@/store";

// const URL = "http://localhost/api";
// const URLDownload = "http://localhost/api/storage";
// const URLAplication = "http://localhost:8080/";

// const URL = "https://apiv2.meuclube.net.br/api";
// const URLDownload = "https://apiv2.meuclube.net.br/api/storage";
// const URLAplication = "https://meuclube.net.br/";  

const URL = "https://api.meuclube.d3t.com.br/api";
const URLDownload = "https://api.meuclube.d3t.com.br/api/storage";
const URLAplication = "https://meuclube.d3t.com.br/";   

class Api {
    static append(formData, data, key) {
        if (
            Object.keys(data[key]).length > 0 && ["string", "number", "boolean"].indexOf(typeof data[key]) == -1
        ) {
            for (let jovana in data[key]) {
                if (jovana != "name") {
                    formData.append(`${jovana}[]`, data[key][jovana]);
                }
            }
            return false;
        }
        formData.append(key, data[key]);
    }

    static appendSingle(formData, data, key) {
        if (Array.isArray(data[key])) {
            data[key].forEach(item => {
                formData.append(`${key}[]`, item);
            });
            return false;
        }
        formData.append(key, data[key]);
    }

    static async validaEdicaoModulo(path) {
        const { data } = await axios.get(`${URL}/valida-edicao-modulo?path=` + path, this._getRequestOptions())
            .catch(err => {
                console.error("validaEdicaoModulo");
                console.error(err);
                throw err;
            });
        return data.length ? true : false;
    }

    static async validaDashboardVisualizacao() {
        const { data } = await axios.get(`${URL}/valida-dashboard-visualizacao`, this._getRequestOptions())
            .catch(err => {
                console.error("validaDashboardVisualizacao");
                console.error(err);
                throw err;
            });
        return data;
    }

    static get(path) {
        return axios.get(`${URL}${path}`, this._getRequestOptions());
    }

    static post(path, body) {
        return axios.post(`${URL}${path}`, body, {
            headers: this._getHeaders()
        });
    }

    static postUpload(path, data) {
        const formData = new FormData();
        Object.keys(data).forEach(key => {
            this.append(formData, data, key);
        });
        return axios.post(`${URL}${path}`, formData, this._getRequestOptions());
    }

    static postUploadSingle(path, data) {
        const formData = new FormData();
        Object.keys(data).forEach(key => {
            this.appendSingle(formData, data, key);
        });
        return axios.post(`${URL}${path}`, formData, this._getRequestOptions());
    }

    static put(path, body) {
        return axios.put(`${URL}${path}`, body, this._getRequestOptions());
    }

    static putUpload(path, data) {
        const formData = new FormData();
        Object.keys(data).forEach(key => {
            this.append(formData, data, key);
        });
        formData.append("_method", "PUT");
        return axios.post(`${URL}${path}`, formData, this._getRequestOptions());
    }

    static putUploadSingle(path, data) {
        const formData = new FormData();
        Object.keys(data).forEach(key => {
            this.appendSingle(formData, data, key);
        });
        formData.append("_method", "PUT");
        return axios.post(`${URL}${path}`, formData, this._getRequestOptions());
    }

    static delete(path) {
        return axios.delete(`${URL}${path}`, this._getRequestOptions());
    }

    static _getRequestOptions(options = {}) {
        let requestOption = {};
        requestOption.headers = this._getHeaders(options.headers);
        return requestOption;
    }
    static _getHeaders(adicionalHeaders) {
        let headers = {
            "Content-Type": "application/json"
        };
        if (localStorage.getItem('token')) {
            headers.Authorization = localStorage.getItem('token');
        }
        if (localStorage.getItem('user-token')) {
            headers.UserToken = localStorage.getItem('user-token');
        }

        if (adicionalHeaders) {
            headers = {
                ...headers,
                ...adicionalHeaders
            };
        }
        return headers;
    }

    static getApiUrl() {
        return URLDownload;
    }
    static getApUrl() {
        return URL;
    }
    static getAplicationUrl() {
        return URLAplication;
    }
}

export default Api;

export const API_URL = URL;